import React from 'react';
import { SelectField } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';

const styles = {
  greenText: { color: green[500] },
  orangeText: { color: orange[500] }
};

const InvestorStatusSelectField = withStyles(styles)(
  ({ classes, ...props }) => {
    let optionClass = '';
    const status = props.record && props.record.investorStatus;
    switch (status) {
      case 'ACTIVE':
        optionClass = classes.greenText;
        break;
      case 'INACTIVE':
        optionClass = classes.orangeText;
        break;
      default:
        break;
    }

    return <SelectField sortable={false} className={optionClass} {...props} />;
  }
);

export default InvestorStatusSelectField;
